import Head from "next/head";
import { Box, Heading, Text } from "@chakra-ui/react";
import { Link } from "@sitecore-jss/sitecore-jss-nextjs";

/**
 * Rendered in case if we have 404 error
 */
const NotFound = () => (
    <>
        <Head>
            <title>404: NotFound</title>
        </Head>
        <Box p={10}>
            <Heading>Page not found</Heading>
            <Text>This page does not exist.</Text>
            <Link field={{ value: { href: "/" } }}>Go to the Home page</Link>
        </Box>
    </>
);

export default NotFound;
